export default __webpack_public_path__ + "static/media/4.02351a52.jpg";